import { Navigate, Route, Routes } from "react-router-dom";
import { Box } from "@mui/material";
import LeadTypes from "./Components/LeadTypes/LeadTypes";
import SettingTabs from "./Components/SettingTabs/SettingTabs";
import UserManagement from "./Components/UserManagement/UserManagement";
import { useStore } from "src/Shared/Hooks";
import { Roles } from "src/Modules/Company/Enums/Roles.enum";
import { observer } from "mobx-react";
import Permission from "src/Shared/Components/Permission/Permission";

const SettingModule = () => {
  const {
    rootStore: { authStore },
  } = useStore();

  const user = authStore.user;

  return (
    <Box sx={{ m: 1 }}>
      <Routes>
        <Route element={<SettingTabs />}>
          <Route index element={<Navigate to="lead-types" replace />} />
          <Route path="lead-types" element={<LeadTypes />} />
          <Route
            path="user-management"
            element={
              <Permission permission="CRM.UserManagement" redirect>
                <UserManagement />
              </Permission>
            }
          />
        </Route>
      </Routes>
    </Box>
  );
};

export default observer(SettingModule);